(function () {
  'use strict';

  angular.module('sempraWebapp').controller('dashboardFinancesController', dashboardFinancesController);

  /** @ngInject */
  function dashboardFinancesController ($timeout, $translate, reportExportUtil, exportToCsv, dailyFinancesActions, $scope, DashboardFinancesViewModel, broker, webSocketsStore, layoutActions) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onFinancesChangedHandler = refreshFinances,
      _onDeviceDataChangeHandler = refreshDevice;

    vm.dashboard = null;
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      layoutActions.showLoader();
      dailyFinancesActions.getData().then(function (data) {
        layoutActions.hideLoader();
        vm.dashboard = new DashboardFinancesViewModel(data);

        subscribeToSocket();
        webSocketsStore.on(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        webSocketsStore.on(webSocketsStore.events.DAILY_FINANCES_CHANGE, _onFinancesChangedHandler);
        webSocketsStore.on(webSocketsStore.events.DEVICE_STATE_CHANGE, _onDeviceDataChangeHandler);
      }, function () {
        //todo error handling
      });
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.dashboard !== null) {
        vm.dashboard.destroy();
        webSocketsStore.off(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        webSocketsStore.off(webSocketsStore.events.DAILY_FINANCES_CHANGE, _onFinancesChangedHandler);
        webSocketsStore.off(webSocketsStore.events.DEVICE_STATE_CHANGE, _onDeviceDataChangeHandler);
      }
    }

    function subscribeToSocket () {
      if (webSocketsStore.isConnected()) {
        var deviceSerialArray = vm.dashboard.finances.map(function (financesViewModel) {
          return financesViewModel.deviceSerial;
        });
        broker.subscribeToDeviceChanges(deviceSerialArray);
        broker.subscribeToFinanceChanges(deviceSerialArray);
      }
    }

    function refreshFinances (newFinancesJson) {
      $timeout(function () {
        vm.dashboard.refreshTileFinances(newFinancesJson);
      }, 50);
    }

    function refreshDevice (newDeviceDataJson) {
      $timeout(function () {
        vm.dashboard.refreshTileDevice(newDeviceDataJson);
      }, 50);
    }

    function exportCsv (financesJson) {
      var exportData = [getObjectForExport(financesJson)];
      exportToCsv.export(exportData,
          $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL'),
          true);
    }

    function getObjectForExport (financesJson) {
      return {
        facility: financesJson.chartData.facilityName,
        totalPayments: financesJson.totalPayments,
        tokensCount: financesJson.tokensCount,
        localTokensCount: financesJson.localTokensCount,
        cashPayments: financesJson.chartData.totalCashPayments,
        onlinePayments: financesJson.chartData.totalOnlinePayments,
        tokenPayments: financesJson.chartData.totalTokenPayments
      };
    }


  }
})();
